import { PureComponent } from 'react';
import { connect } from 'react-redux';

import pick from 'lodash/pick';
import PropTypes from 'prop-types';

import MainComponent from './MainComponent';

import { logout } from '../Auth/actionCreators';
import { getDashboardInfo } from '../Shared/actions';
import { setDrawerOpen } from './actions';

import {
  isAdmin,
  isAuthenticated,
  isSessionExpired,
  saveLastActivityTime,
} from '../../utils';
import { getUserInfo, toggleIsNavigationShown } from '../Navigation/utils';
import { setGAUser } from '../Shared/utils/ga';

import * as commonSelectors from '../Shared/selectors';

class MainContainer extends PureComponent {
  componentDidMount() {
    const { currentUser, logOut, toggleIsNavigationShown } = this.props;

    if (isAuthenticated() && !currentUser) return logOut();
    if (isAuthenticated() && isSessionExpired()) return logOut();

    if (currentUser?.id) {
      setGAUser(currentUser);
    }

    return toggleIsNavigationShown();
  }

  componentDidUpdate(prevProps) {
    const { isMobileScreen, setDrawerOpen, getDashboardInfo } = this.props;

    if (isAuthenticated() && !this.dashboardPoll && !isAdmin()) {
      // get dashboard info (used for msgs and notifications badges) every 10 min
      getDashboardInfo();
      const interval = 10 * 60 * 1000;
      this.dashboardPoll = setInterval(() => getDashboardInfo(), interval);
    }

    if (!isAuthenticated() && this.dashboardPoll) {
      this.clearDashboardPoll();
    }

    if (isAuthenticated() && !window.onbeforeunload) {
      window.addEventListener('beforeunload', saveLastActivityTime);
      saveLastActivityTime();
    }

    if (!isAuthenticated() && window.onbeforeunload) {
      window.removeEventListener('beforeunload', saveLastActivityTime);
    }

    if (isMobileScreen !== prevProps.isMobileScreen) {
      // see setDrawerOpen logic in SideNavContainer
      isMobileScreen && setDrawerOpen(false);
    }
  }

  componentWillUnmount() {
    this.clearDashboardPoll();
  }

  clearDashboardPoll() {
    if (!this.dashboardPoll) return;
    clearInterval(this.dashboardPoll);
    this.dashboardPoll = null;
  }

  render() {
    const props = pick(this.props, [
      'currentUser',
      'isDrawerOpen',
      'isNavigationShown',
    ]);

    return <MainComponent {...props} />;
  }
}

MainContainer.propTypes = {
  currentUser: PropTypes.instanceOf(Object).isRequired,
  setDrawerOpen: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired,
  toggleIsNavigationShown: PropTypes.func.isRequired,
  getDashboardInfo: PropTypes.func.isRequired,
  isMobileScreen: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const currentUser = commonSelectors.getCurrentUser(state);
  const isDrawerOpen = commonSelectors.getIsDrawerOpen(state);
  const isNavigationShown = commonSelectors.isNavigationShown(state);
  const isMobileScreen = commonSelectors.getIsMobileScreen(state);
  return {
    currentUser,
    isDrawerOpen,
    isNavigationShown,
    isMobileScreen,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setUser: () => getUserInfo(dispatch),
  getDashboardInfo: () => getDashboardInfo(dispatch, true),
  setDrawerOpen: (isDrawerOpen) => setDrawerOpen(dispatch, isDrawerOpen),
  toggleIsNavigationShown: () =>
    toggleIsNavigationShown(dispatch, isAuthenticated()),
  logOut: () => logout(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);
